module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'employeeReports',
        preventClearOnCancel: true,
    },
}